import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, fromEvent, merge, map, startWith } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ConnectivityService {
  private readonly onlineSubject = new BehaviorSubject<boolean>(
    typeof navigator !== 'undefined' ? navigator.onLine : true
  );

  readonly online$ = this.onlineSubject.asObservable();

  constructor(zone: NgZone) {
    if (typeof window === 'undefined') {
      return;
    }
    zone.runOutsideAngular(() => {
      merge(fromEvent(window, 'online'), fromEvent(window, 'offline'))
        .pipe(
          map(() => navigator.onLine),
          startWith(navigator.onLine)
        )
        .subscribe((online) => {
          zone.run(() => this.onlineSubject.next(online));
        });
    });
  }

  isOnline(): boolean {
    return this.onlineSubject.value;
  }
}
